import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Note from '../views/Note.vue'
import Search from '../views/Search.vue'
import Label from '../views/Label.vue'
import Check from '../views/Check.vue'
import Trash from '../views/Trash.vue'
import History from '../views/History.vue'

import MonitorsDashboard from '../views/MonitorsDashboard.vue'
import MonitorsDashboardCategory from '../views/MonitorsDashboardCategory.vue'
import MonitorsDashboardSubCategory from '../views/MonitorsDashboardSubCategory.vue'
import MonitorsDetails from '../views/MonitorsDetails.vue'
import MonitorsParagraphs from '../views/MonitorsParagraphs.vue'
import MonitorsParagraphsObjects from '../views/MonitorsParagraphsObjects.vue'
import MonitorsTrash from '../views/MonitorsTrash.vue'
// import MonitorsChaptersTrash from '../views/MonitorsChaptersTrash.vue'
import MonitorsHistory from '../views/MonitorsHistory.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/note/:slug',
    name: 'Note',
    props: true,
    component: Note
  },
  {
    path: '/search',
    name: 'Search',
    component: Search
  },
  {
    path: '/label',
    name: 'Label',
    component: Label
  },
  {
    path: '/check',
    name: 'Check',
    props: true,
    component: Check
  },
  {
    path: '/trash/:type/:id?',
    name: 'Trash',
    props: true,
    component: Trash
  },
  {
    path: '/history/:id',
    name: 'History',
    component: History
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },

  {
    path: '/monitors/dashboard',
    name: 'MonitorsDashboard',
    component: MonitorsDashboard
  },
  {
    path: '/monitors/dashboard/:category',
    name: 'MonitorsDashboardCategory',
    component: MonitorsDashboardCategory
  },
  {
    path: '/monitors/dashboard/:category/:tagId',
    name: 'MonitorsDashboardSubCategory',
    component: MonitorsDashboardSubCategory
  },
  {
    path: '/monitors/:id',
    name: 'MonitorsDetails',
    component: MonitorsDetails
  },
  {
    path: '/monitors/:monitorId/chapters/:chapterId',
    name: 'MonitorsParagraphs',
    component: MonitorsParagraphs
  },
  {
    path: '/monitors/:monitorId/chapters/:chapterId/paragraphs/:paragraphId',
    name: 'MonitorsParagraphsObjects',
    component: MonitorsParagraphsObjects
  },
  {
    path: '/monitors/trash/:type/:tagId',
    name: 'MonitorsTrash',
    props: true,
    component: MonitorsTrash
  },
  // {
  //   path: '/monitors/trash/:monitorId',
  //   name: 'MonitorsChaptersTrash',
  //   props: true,
  //   component: MonitorsChaptersTrash
  // },
  {
    path: '/monitors/history/:tagId',
    name: 'MonitorsHistory',
    props: true,
    component: MonitorsHistory
  },

  {
    path: '*',
    redirect: '/dashboard'
  }
]

const router = new VueRouter({
  mode: 'history', /* Source: https://router.vuejs.org/guide/essentials/history-mode.html#example-server-configurations */
  routes: routes,
})

export default router
